import { useState, useEffect } from "react";
import {
  Typography,
  Box,
  InputBase,
  Tooltip,
  IconButton,
  Button,
  DialogContent,
  Dialog,
} from "@mui/material";
import { DataGrid, faIR } from "@mui/x-data-grid";
import Detail from "../../main/detail/Detail";
import { rsActiveMenu, rsProgress } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import { UseSearchAdvertisment } from "./UseSearchAdvertisment";
import { useNavigate, useLocation } from "react-router-dom";
import { UseMyPC } from "../../hooks/UseMyPC";
import CustomPagination from "../../components/CustomPagination";
import { deCapitalizeFirstLetter } from "../../util/Utils";
import ProgressCom from "../../components/ProgressCom";
import YesOrNoDialoge from "../../components/YesOrNoDialoge";
import LockIcon from "@mui/icons-material/Lock";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import useBreakpoints from "../../hooks/useBreakpoints";
import SearchComOff from "../firstPage/HomeOffer/SearchComOff";
import { useSnackbar } from "notistack";
import DeleteIcon from "@mui/icons-material/Delete";

export default function SearchAdvertisment() {
  const { enqueueSnackbar } = useSnackbar();
  const {
    myPc,
    goToLastPage,
    goToFirstPage,
    updatePage,
    updateSort,
    setScrollTo,
    refresh,
  } = UseMyPC("Id", "Desc");
  let navigate = useNavigate();
  const location = useLocation();
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const [progress, setProgress] = useRecoilState(rsProgress);
  const { GetSearchAdvertisment, UpdateSearchAdvertisment } =
    UseSearchAdvertisment();
  const [productRes, setProductRes] = useState();
  const [state, setState] = useState({ id: undefined, active: true });
  const { isSmall } = useBreakpoints();
  const [openDialog, setOpenDialog] = useState(false);

  const [searchState, setSearchState] = useState(
    location.state && location.state.search ? location.state.search : ""
  );
  const [search, setSearch] = useState(
    location.state && location.state.search ? location.state.search : ""
  );

  useEffect(() => {
    if (
      myPc.page === 0 ||
      (location.state && location.state && location.state.isBack)
    ) {
      return;
    }
    setProgress(true);
    GetSearchAdvertisment(myPc, search, true, (advs) => {
      setProgress(false);
      setProductRes(advs);
    });
  }, [myPc]);

  function handleSearch(value) {
    setScrollTo(undefined);
    location.state = null;
    setSearch(value);
  }
  const [checkState, setCheckState] = useState({
    show: false,
    name: undefined,
  });

  useEffect(() => {
    if (location.state && location.state) {
      location.state.isBack = false;
    }
    if (search.length > 0 && !location.state) {
      goToFirstPage();
    } else {
      refresh();
    }
  }, [search]);

  const newFunc = () => {
    return setOpenDialog(true);
  };

  const columns = [
    {
      field: "id",
      width: 80,
      align: "center",
      headerName: "ID",
      headerAlign: "center",
      sortable: false,
    },
    {
      field: "faName",
      width: 270,
      align: "center",
      headerName: "نام محصول",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography
            variant="span"
            sx={{ whiteSpace: "normal", cursor: "pointer" }}
          >
            {cellValues.row.faName}
          </Typography>
        );
      },
    },
    {
      field: "groupName",
      headerName: "گروه",
      width: 270,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.groupName}
          </Typography>
        );
      },
    },
    {
      field: "عملیات",
      sortable: false,
      width: 90,
      headerAlign: "center",
      align: "center",
      headerName: "عملیات",
      renderCell: (cellValues) => {
        return (
          <Tooltip title="حذف">
            <IconButton
              sx={{ p: 0.5, mr: 0.5 }}
              onClick={() => {
                setCheckState({
                  show: true,
                  active: false,
                  id: cellValues.row.id,
                  name: "غیرفعال کردن محصول " + cellValues.row.faName,
                });
              }}
            >
              <DeleteIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        );
      },
    },
    {
      field: "search",
      width: 250,
      sortable: false,
      renderHeader: (cellValues) => {
        return (
          <Box
            sx={{ border: "1px solid #d3d3d3", borderRadius: 1 }}
            width="auto"
            display="flex"
            justifyContent="flex-start"
          >
            <InputBase
              sx={{ ml: 2, flex: 1 }}
              placeholder="جستجو"
              fullWidth
              value={searchState}
              inputProps={{ "aria-label": "search" }}
              onChange={(evt) => {
                if (evt.target.value == "") {
                  handleSearch("");
                }
                setSearchState(evt.target.value);
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleSearch(searchState);
                }
              }}
            />
          </Box>
        );
      },
    },
  ];

  return (
    <Detail
      breadChilds={{
        title: "ارتباط با مشتری",
        childs: [{ name: msActiveMenu.pageTitle, url: "/searchadvmanage" }],
      }}
    >
      <Dialog
        PaperProps={{
          elevation: 1,
        }}
        fullWidth
        open={openDialog}
        onClose={() => {
          setState({
            id: "",
            active: true,
          });
          setOpenDialog(false);
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
              gap: 3,
            }}
          >
            <SearchComOff
              searchAdv
              // article={isSmall ? true : false}
              productID={state.id}
              productModel={state}
              setProductModel={setState}
            />
            <Box>
              <Button
                onClick={() => {
                  if (
                    state.id == "" ||
                    state.id == undefined ||
                    state.id == null
                  ) {
                    enqueueSnackbar("لطفا محصول را وارد کنید", {
                      variant: "error",
                      autoHideDuration: 2000,
                      preventDuplicate: true,
                    });
                    return;
                  } else {
                    setProgress(true);
                    UpdateSearchAdvertisment(state, () => {
                      setState({
                        id: "",
                        active: true,
                      });
                      setOpenDialog(false);

                      GetSearchAdvertisment(myPc, search, false, (advs) => {
                        setProductRes(advs);
                      });
                    });
                  }
                }}
                color="secondary"
                variant="contained"
              >
                ثبت
              </Button>
              <Button
                sx={{ ml: 2 }}
                color="secondary"
                variant="outlined"
                onClick={() => {
                  setState({
                    id: "",
                    active: true,
                  });
                  setOpenDialog(false);
                }}
              >
                انصراف
              </Button>
            </Box>
          </Box>
        </DialogContent>
      </Dialog>
      {productRes ? (
        <DataGrid
          className="ltr-grid"
          localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
          columns={columns}
          pageSize={productRes.pageCondition.pageCount}
          rows={productRes.item}
          paginationMode="server"
          page={productRes.pageCondition.page - 1}
          onPageChange={(page) => {
            updatePage(page + 1);
          }}
          rowCount={productRes.pageCondition.totalItemCount}
          enableRangeSelection={true}
          disableColumnMenu
          hideFooterSelectedRowCount
          components={{
            Pagination: CustomPagination,
          }}
          componentsProps={{
            pagination: {
              scrollTo: myPc.scrollTo,
              isLtr: true,
              newFunc: newFunc,

              rowCount: productRes.pageCondition.totalItemCount,
            },
          }}
          initialState={{
            sorting: {
              sortModel: [
                {
                  field: deCapitalizeFirstLetter(myPc.sortColumn),
                  sort: deCapitalizeFirstLetter(myPc.sortOrder),
                },
              ],
            },
            pagination: {
              page: myPc.page,
            },
          }}
          sx={{
            "& .MuiDataGrid-cell:focus": {
              outline: "none",
            },
            "&  .MuiDataGrid-columnHeader:focus-within": {
              outline: "none",
            },
            "&  .MuiDataGrid-cell:focus-within ": {
              outline: "solid rgba(97, 181, 55, 0.5) 0px !important",
            },
            width: "100% !important",
            "& .muirtl-s1v7zr-MuiDataGrid-virtualScrollerRenderZone": {
              width: "100% !Important",
            },
            "&  .MuiDataGrid-filterIcon": {
              display: "none",
            },
            "& .MuiDataGrid-cell:hover": {
              color: "primary.main",
            },
            "& .MuiDataGrid-virtualScrollerRenderZone": {
              width: "100% !important",
            },
            "& .red": {
              width: "100%",
              backgroundColor: "#ff9c9c !important",
            },
            "& .orange": {
              backgroundColor: "#FFC36E !important",
            },
          }}
          getRowClassName={(params) => {
            if (params.row.active == 1) {
              return "red";
            }
            if (params.row.active == 2) {
              return "orange";
            }
          }}
          onSortModelChange={(model) => {
            updateSort(model[0].field, model[0].sort == "asc" ? "asc" : "desc");
          }}
          sortingOrder={["desc", "asc"]}
          sortingMode="server"
        />
      ) : (
        <ProgressCom></ProgressCom>
      )}
      <YesOrNoDialoge
        checkState={checkState}
        setCheckState={setCheckState}
        callback={() => {
          let state = {
            id: checkState.id,
            active: checkState.active,
          };
          setProgress(true);
          UpdateSearchAdvertisment(state, () => {
            GetSearchAdvertisment(myPc, search, false, (advs) => {
              setProductRes(advs);
            });
          });
        }}
      />
    </Detail>
  );
}
